export default __webpack_public_path__ + "static/services-detailsbd-0ac612dc8bd4c3338a218c02901da099.jpg";